export enum AnonymisationLogEntityType {
  CASH_COLLECTION = 'CASH_COLLECTION',
  CASH_COLLECTION_BENEFICIARY = 'CASH_COLLECTION_BENEFICIARY',
}

export interface AnonymisationLog {
  id: string;
  entityType: AnonymisationLogEntityType;
  entityId: string;
  anonymizedAt: string;
  daysPeriod: number;
  render?: Record<string, React.JSX.Element>;
}
